import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function BookingIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M11.23 12.3a2.5 2.5 0 10-3.45 0 4.13 4.13 0 00-2.77 4 1.72 1.72 0 001.7 1.7h5.57A1.72 1.72 0 0014 16.29a4.13 4.13 0 00-2.77-3.99zM8 10.5A1.5 1.5 0 119.5 12 1.5 1.5 0 018 10.5zm4.29 6.5H6.71a.71.71 0 01-.71-.71A3.25 3.25 0 019.5 13a3.29 3.29 0 013.5 3.29.71.71 0 01-.71.71z"/>
      <path d="M20.21 3H18v-.5a.5.5 0 00-1 0V3H7v-.5a.5.5 0 00-1 0V3H3.79A1.79 1.79 0 002 4.79v14.42A1.79 1.79 0 003.79 21h16.42A1.79 1.79 0 0022 19.21V4.79A1.79 1.79 0 0020.21 3zM21 19.21a.79.79 0 01-.79.79H3.79a.79.79 0 01-.79-.79V4.79A.79.79 0 013.79 4H6v1.5a.5.5 0 001 0V4h10v1.5a.5.5 0 001 0V4h2.21a.79.79 0 01.79.79z"/>
      <path d="M18.5 10h-3a.5.5 0 000 1h3a.5.5 0 000-1zm0 3h-3a.5.5 0 000 1h3a.5.5 0 000-1z"/>
    </SvgIcon>
  )
}
export default BookingIcon
